/**
 * Get the variant picker from the product template
 * and insert it into the product info container.
 * 
 * this has to be done because the variant picker is being removed
 * by the bundle app.
 */
(function () {
    document.addEventListener("DOMContentLoaded", async function () {
        const productInfoContainer = document.querySelector("[id^='ProductInfo-template-']");
        let variantRadios = productInfoContainer?.querySelector("variant-radios");
        const section_id = productInfoContainer.dataset.sectionId;
    
        if (variantRadios) return;
    
        const currentRoute = window.location.pathname;
        const response = await fetch(`${currentRoute}?section_id=${section_id}`);
    
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
    
        variantRadios = doc.querySelector("variant-radios");

        if (!variantRadios) return;
        
      const form = productInfoContainer.querySelector(`form[method='post'][id='product-form-installment-${section_id}']`);
      form?.parentElement?.insertAdjacentElement("afterend", variantRadios);

    });
})();